module.exports = __webpack_public_path__ + "img/download.e47b962f.svg";